export default function globalVariables() {
    const body = document.querySelector('body');
    const projects = document.querySelectorAll('figure, .typer_wrapper, .posters');
    const scrollable = document.documentElement;
    const opener = document.querySelector('.opener');
    let projectHeaderHeight = 0;
    let combinedHeaderHeight = 0;
  }